// Original idea was found here
// https://medium.com/@alshakero/how-to-setup-your-web-app-manifest-dynamically-using-javascript-f7fbee899a61

import { DEBUG } from '../config';
import { IS_MAC_OS } from './browser/windowEnvironment';

export default function updateWebmanifest() {
  if (!IS_MAC_OS) {
    return;
  }

  const manifest = document.getElementById('the-manifest-placeholder');
  if (!manifest) {
    return;
  }

  const url = `site_apple${DEBUG ? '_dev' : ''}.webmanifest`;

  // Fetch manifest as JSON, resolve relative URLs to absolute (blob: URLs have no base path),
  // then set as blob URL to avoid ERR_CONNECTION_CLOSED on flaky connections.
  const baseUrl = `${window.location.origin}/`;

  fetch(url)
    .then((res) => {
      if (!res.ok) return undefined;
      return res.json();
    })
    .then((data) => {
      if (!data) return;

      if (data.start_url) {
        data.start_url = new URL(data.start_url, baseUrl).href;
      }
      if (data.icons) {
        data.icons = data.icons.map((icon: { src: string }) => ({
          ...icon,
          src: new URL(icon.src, baseUrl).href,
        }));
      }
      if (data.screenshots) {
        data.screenshots = data.screenshots.map((s: { src: string }) => ({
          ...s,
          src: new URL(s.src, baseUrl).href,
        }));
      }
      if (data.share_target?.action) {
        data.share_target.action = new URL(data.share_target.action, baseUrl).href;
      }

      const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
      manifest.setAttribute('href', URL.createObjectURL(blob));
    })
    .catch(() => { /* Manifest is non-critical, silently ignore network errors */ });
}
